/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WMGenericMovementRequest
 */
export interface WMGenericMovementRequest {
    /**
     * 
     * @type {string}
     * @memberof WMGenericMovementRequest
     */
    destinationLocationCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WMGenericMovementRequest
     */
    initLocationCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WMGenericMovementRequest
     */
    materialCode?: string;
    /**
     * 
     * @type {number}
     * @memberof WMGenericMovementRequest
     */
    materialQty?: number;
    /**
     * 
     * @type {string}
     * @memberof WMGenericMovementRequest
     */
    operatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof WMGenericMovementRequest
     */
    warehouseCode?: string;
}

/**
 * Check if a given object implements the WMGenericMovementRequest interface.
 */
export function instanceOfWMGenericMovementRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WMGenericMovementRequestFromJSON(json: any): WMGenericMovementRequest {
    return WMGenericMovementRequestFromJSONTyped(json, false);
}

export function WMGenericMovementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WMGenericMovementRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'destinationLocationCode': !exists(json, 'destinationLocationCode') ? undefined : json['destinationLocationCode'],
        'initLocationCode': !exists(json, 'initLocationCode') ? undefined : json['initLocationCode'],
        'materialCode': !exists(json, 'materialCode') ? undefined : json['materialCode'],
        'materialQty': !exists(json, 'materialQty') ? undefined : json['materialQty'],
        'operatorId': !exists(json, 'operatorId') ? undefined : json['operatorId'],
        'warehouseCode': !exists(json, 'warehouseCode') ? undefined : json['warehouseCode'],
    };
}

export function WMGenericMovementRequestToJSON(value?: WMGenericMovementRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'destinationLocationCode': value.destinationLocationCode,
        'initLocationCode': value.initLocationCode,
        'materialCode': value.materialCode,
        'materialQty': value.materialQty,
        'operatorId': value.operatorId,
        'warehouseCode': value.warehouseCode,
    };
}

